import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getAllGroups(showLoader = true): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/groups`, { showLoader, showMessage: false });
  }

  getAllUsers(): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/lookup/users`, {
      showLoader: true,
      showMessage: false
    });
  }

  submitAddGroupForm(request: any): Observable<any> {
    return this.#http.postData<any>(`${this.baseUrl}/groups`, { showLoader: true, showMessage: true }, request);
  }

  addMembers(groupId: string, selectedMembers: any): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/groups/${groupId}/members`,
      { showLoader: true, showMessage: true },
      { userIds: selectedMembers }
    );
  }

  removeMember(groupId: string, memberId: string): Observable<any> {
    return this.#http.deleteData<any>(`${this.baseUrl}/groups/${groupId}/members/${memberId}`, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteGroup(groupId: string): Observable<any> {
    return this.#http.deleteData<any>(`${this.baseUrl}/groups/${groupId}`, {
      showLoader: true,
      showMessage: true
    });
  }

  editGroup(groupId: string, request: any): Observable<any> {
    return this.#http.putData<any>(`${this.baseUrl}/groups/${groupId}`, request, {
      showLoader: true,
      showMessage: true
    });
  }
}
